import { render, staticRenderFns } from "./usuarioAdd.vue?vue&type=template&id=24d47588&"
import script from "./usuarioAdd.vue?vue&type=script&lang=js&"
export * from "./usuarioAdd.vue?vue&type=script&lang=js&"
import style0 from "./usuarioAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports